module.exports = __webpack_public_path__ + "static/img/9-中银国际.215687a8.png";